/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { toConsumableArray as _toConsumableArray } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { buildHierarchy as _buildHierarchy } from './sorting.js';

var isMatchingInputValue = function isMatchingInputValue(item, inputValue, itemToString) {
  return !inputValue || itemToString(item).toLowerCase().includes(inputValue.toLowerCase()) || item.tag && item.tag.toLowerCase().includes(inputValue.toLowerCase());
};
var _getAllChildren = function getAllChildren(item, items) {
  var results = [];
  var children = items.filter(function (theItem) {
    return theItem.parentId && theItem.parentId === item.id;
  });
  if (children.length > 0) {
    results.push.apply(results, _toConsumableArray(children));
    children.forEach(function (child) {
      results.push.apply(results, _toConsumableArray(_getAllChildren(child, items)));
    });
  }
  return results;
};
var defaultFilterItems = function defaultFilterItems(items, _ref) {
  var itemToString = _ref.itemToString,
    inputValue = _ref.inputValue,
    expandedItems = _ref.expandedItems,
    _ref$tags = _ref.tags,
    tags = _ref$tags === void 0 ? [] : _ref$tags;
  return items.filter(function (item) {
    var parents = _buildHierarchy(item, items);
    parents.pop();
    if (parents.length > 0 && expandedItems) {
      // If any parent item is not expanded, the child item should not be shown
      var isExpanded = !parents.some(function (parent) {
        return !expandedItems.some(function (expandedItem) {
          return expandedItem.id === parent.id;
        });
      });
      if (!isExpanded) {
        return false;
      }
    }
    if (!inputValue && tags.length === 0) {
      return true;
    }
    var children = _getAllChildren(item, items).filter(function (theItem) {
      return isMatchingInputValue(theItem, inputValue, itemToString);
    });
    if (children.length > 0) {
      // if any of the child item matches, the parent item should be shown
      return true;
    }
    if (parents.length > 0) {
      var isVisible = parents.some(function (parent) {
        return isMatchingInputValue(parent, inputValue, itemToString);
      });
      if (isVisible) {
        // if it matches any of the parents, all sub items should be shown
        return true;
      }
    }
    return isMatchingInputValue(item, inputValue, itemToString);
  });
};

export { defaultFilterItems, _getAllChildren as getAllChildren };
